module.exports = __webpack_public_path__ + "static/media/deliv2.a2f10f24.svg";